import {
  LOADING_DATA_ON_PAGE_LOAD,
  SAVED_ITEMS_SDK_FAILURE
} from "../../../modules/savedItems/constants";
import isAppOnline from "../../../../providers/applicationOnlineStatusProvider";

export const beginAndCheckOnlineStatus = dispatch => {
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: true });
  if (!isAppOnline()) {
    dispatch({ type: SAVED_ITEMS_SDK_FAILURE });

    return false;
  }

  return true;
};
